angular.module('olivioConfiguratorApp')
  .controller('ProductCtrl', function ($scope, $rootScope, Model, Data, StepService) {
    //console.log('init ProductCtrl');

    $scope.OLIVIO = OLIVIO;
    $scope.model = Model.model;
    $scope.data = Data;

    $scope.selectProduct = function ($id) {
      var product = Data.getProductOption($id);
      if (product) {
        if ($scope.model.product.id !== $id) {
          console.log('-- selectProduct '+$id, ''+$scope.model.design.lumtype,  $scope.model);
          $scope.model.product.id = $id;
          console.log('-- selectProduct '+$id, ''+$scope.model.design.lumtype, $scope.model);
          Model.resetDesign();
          StepService.configurationSteps.filter(s => s.view === 'power')[0].skipped = false;
          console.log('^- selectProduct '+$scope.model.product.id, ''+$scope.model.design.lumtype, $scope.model);
        }
        $scope.model.product.done = true;
        StepService.nextStep();
      } // TODO else software configuration error
    };
  });
